import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ResumeBuilder from './components/ResumeBuilder';
import LocalStorageService from './services/localStorage';
import './App.css';

function App() {
  const [userInfo, setUserInfo] = useState({ name: '', email: '' });

  // Initialize user data from localStorage on app start
  useEffect(() => {
    const savedUserData = LocalStorageService.getUserData();
    if (savedUserData) {
      setUserInfo({
        name: savedUserData.name,
        email: savedUserData.email
      });
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/" 
            element={<LandingPage userInfo={userInfo} setUserInfo={setUserInfo} />} 
          />
          <Route 
            path="/resume-builder" 
            element={<ResumeBuilder userInfo={userInfo} setUserInfo={setUserInfo} />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
